import { CuffaMeasurementUnitEnum, CuffaProductTypeEnum } from 'common/enums';
import { ICuffaProduct } from './index';
import { getAllowedUnits } from 'utils/forms/cuffa_functions';

export const computeProductionTypes = (
    currentProductionTypes: string[],
    currentSelectedProducts: ICuffaProduct[],
    value: string,
    checked: boolean,
) => {
    let newArray = [...currentProductionTypes];
    let newSelectedProducts = [...currentSelectedProducts];

    if (checked) {
        if (!newArray.includes(value)) newArray.push(value);
    } else {
        newArray = newArray.filter((v) => v !== value);
        newSelectedProducts = newSelectedProducts.filter(
            (p) => !newArray.includes(p.production_type as any),
        );
    }

    return { productionTypes: newArray, selectedProducts: newSelectedProducts };
};

export const toggleProductSelection = (
    selectedProducts: ICuffaProduct[],
    product: ICuffaProduct,
    checked: boolean,
) => {
    const newSelectedProducts = [...selectedProducts];
    const key = (product.id ?? product.uuid) as any;
    if (checked) {
        if (!newSelectedProducts.find((p) => (p.id ?? p.uuid) === key)) {
            newSelectedProducts.push({
                ...product,
                quantity: 1,
                unit: getAllowedUnits(product.name, product.production_type, product.is_processed)[0],
            });
        }
    } else {
        return newSelectedProducts.filter((p) => (p.id ?? p.uuid) !== key);
    }

    return newSelectedProducts;
};

export const buildOtherProduct = (
    otherProductName: string,
    otherProductType: any,
    isProcessed: boolean,
) => {
    return {
        name: otherProductName.trim(),
        production_type: otherProductType,
        product_type: CuffaProductTypeEnum.CUSTOMIZADO,
        is_processed: isProcessed,
        is_active: true,
        quantity: 1,
        unit: getAllowedUnits(otherProductName, otherProductType, isProcessed)[0],
    } as ICuffaProduct;
};

export const updateSelectedProductsQuantity = (
    selectedProducts: ICuffaProduct[],
    productKey: string,
    newQuantity: number,
) => selectedProducts.map((product, index) => {
    const key = product.id ?? product.uuid ?? `temp-${index}`;
    return key === productKey ? { ...product, quantity: newQuantity } : product;
});

export const updateSelectedProductsUnit = (
    selectedProducts: ICuffaProduct[],
    productKey: string,
    newUnit: CuffaMeasurementUnitEnum,
) => selectedProducts.map((product, index) => {
    const key = product.id ?? product.uuid ?? `temp-${index}`;
    return key === productKey ? { ...product, unit: newUnit } : product;
});

export const removeProductByKey = (selectedProducts: ICuffaProduct[], productKey: string) =>
    selectedProducts.filter((product, index) => {
        const key = product.id ?? product.uuid ?? `temp-${index}`;
        return key !== productKey;
    });

export const updateAvailabilityMonths = (
    availability: Record<string, any> | undefined,
    monthKey: string,
    checked: boolean,
    monthsList: { key: string }[],
) => {
    const newAvailability: Record<string, any> = { ...(availability ?? {}) };
    const key = monthKey as string;

    if (monthKey === 'available_year_round') {
        if (checked) {
            monthsList.forEach((m) => {
                newAvailability[m.key] = false;
            });
            newAvailability.available_year_round = true;
        } else {
            newAvailability.available_year_round = false;
        }
    } else {
        if (checked) newAvailability.available_year_round = false;
        newAvailability[key] = checked;
    }

    return newAvailability;
};

export default {};
